module.exports = __webpack_public_path__ + "media/reskin-images/onboarding--welcome-1-16247987.png";